<template>
  <section class="guidance-display-screen">
    <div class="searchbox">
      <form action="#" method="get" class="form-inline form-float">
        <div class="form-group">
          <label for>诱导屏等级:</label>
          <el-select
            v-model="search.inductLevel"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in inductLeveType"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
        <div class="form-group">
          <label for>控制卡ID:</label>
          <input
            v-model.trim="search.ledcardId"
            class="form-control"
            type="text"
            placeholder
            size="12"
            v-noBlankSpace
          />
        </div>
        <div class="form-group">
          <label for>控制卡状态:</label>
          <el-select
            v-model="search.ledcardStatus"
            clearable
            placeholder="请选择"
          >
            <el-option label="在线" value="online" />
            <el-option label="离线" value="offline" />
          </el-select>
        </div>
        <div class="form-group others">
          <span class="search_btn">
            <button
              @click="searchList"
              type="button"
              class="btn btn-primary"
              id="search_btn"
            >
              查询
            </button>
          </span>
          <span class="add_btn">
            <button
              type="button"
              class="btn btn-default"
              id="addarea"
              @click="addOrEdit()"
            >
              添加
            </button>
          </span>
           <span class='refresh_btn'><Refresh @tableList="tableList"></Refresh></span>
        </div>
      </form>
    </div>
    <div class="list-right">
      <el-table
        ref="table"
        border
        :data="tableListData"
        height="100%"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
        v-loading="tableLoading"
      >
        <el-table-column
          show-overflow-tooltip
          label="屏等级"
          prop="inductLevel"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="屏编号"
          prop="ledNo"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="是否具体车场"
          prop="parkingContentFlag"
        >
          <template slot-scope="scope">
            {{ scope.row.parkingContentFlag === "y" ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="综合屏标题"
          prop="contentCaption"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="关联停车场"
          prop="parkingId"
             width="150"
        >
          <template slot-scope="scope">
            {{ JSON.parse(scope.row.parkingId || "{}").parkingName }}
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="控制卡ID"
          prop="ledcardId"
          width="150"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="控制卡状态"
          prop="ledcardStatus"
             width="100"
        >
          <template slot-scope="scope">
            {{ scope.row.ledcardStatus === "offline" ? "离线" : "在线" }}
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="是否推送信息"
          prop="pushFlag"
        >
          <template slot-scope="scope">
            {{ scope.row.pushFlag === "n" ? "否" : "是" }}
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="内码区域前缀"
          prop="neimaPrefix"
        ></el-table-column>
          <el-table-column
          show-overflow-tooltip
          label="联系人电话"
          prop="attr1"
             width="150"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="备注"
          prop="remark"
        ></el-table-column>
        <el-table-column show-overflow-tooltip label="操作" width="260px">
          <template slot-scope="scope">
            <button type="button" class="edit" @click="publish(scope.row)">
              手动发布
            </button>
            <button type="button" class="edit" @click="addOrEdit(scope.row)">
              修改
            </button>
            <button
              type="button"
              class="edit"
              @click="viewSendLog(scope.row)"
            >
              查看下发记录
            </button>
            <button class="delete" @click="del(scope.row)">删除</button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <Page
      v-on:pagination="receivePaginationData"
      v-bind:pageObj="pageObj"
    ></Page>
    <!-- 添加/编辑-->
    <el-dialog
      title="添加/修改"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :visible.sync="dialogFormVisible"
      width="430px"
    >
      <el-form
        label-position="right"
        :model="form"
        :rules="rules"
        :label-width="formLabelWidth"
        ref="form"
      >
        <el-form-item label="屏等级" prop="inductLevel">
          <el-col :span="18">
            <el-select
              class="check-parking"
              filterable
              clearable
              v-model="form.inductLevel"
            >
              <el-option
                v-for="item in inductLeveType"
                :key="item"
                :value="item"
                :label="item"
              />
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="屏编号" prop="ledNo">
          <el-col :span="18">
            <el-input
              v-model.trim="form.ledNo"
              placeholder="请输入数字"
            ></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="综合屏标题" prop="contentCaption">
          <el-col :span="18">
            <el-input v-model="form.contentCaption"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="关联停车场" prop="parkingId">
          <el-col :span="18">
            <el-select filterable clearable v-model="form.parkingId">
              <el-option
                v-for="item in parks"
                :key="item.parkingId"
                :value="item.parkingId"
                :label="item.parkingName"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="控制卡ID" prop="ledcardId">
          <el-col :span="18">
            <el-input v-model="form.ledcardId"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item prop="pushFlag">
          <el-col :span="18"> </el-col>
        </el-form-item>
        <el-form-item label="内码区域前缀" prop="neimaPrefix">
          <el-col :span="18">
            <el-input v-model="form.neimaPrefix"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="联系电话" prop="attr1">
          <el-col :span="18">
            <el-input v-model="form.attr1" placeholder="请输入联系电话"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-col :span="18">
            <el-input type="textarea" v-model="form.remark"></el-input>
          </el-col>
        </el-form-item>
        <el-col
          :span="18"
          style="display: flex; justify-content: space-around;align-items: center;"
        >
          <el-checkbox
            v-model="form.parkingContentFlag"
            true-label="y"
            false-label="n"
            >是否具体车场</el-checkbox
          >
          <el-checkbox v-model="form.pushFlag" true-label="y" false-label="n"
            >是否推送信息</el-checkbox
          >
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addOrEditTrue">确 定</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </section>
</template>
<script>
import {
  fetchParkigList,
  queryLedInduct,
  queryLedInductOne,
  updateLedInduct,
  publishContent,
} from "@/api/url";

import Page from "../../../commons/page";

import { mapGetters, mapState, mapMutations } from "vuex";
import Refresh from "@/page/commons/refresh.vue";
export default {
  data() {
    return {
      tableLoading: false,
      inductLeveType: ["一级", "二级", "三级"],
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      search: {
        pageNumber: 1,
        pageSize: 10,
        inductLevel: "",
        ledcardId: "",
        ledcardStatus: "",
      },
      tableListData: [],
      pageObj: {},
      dialogFormVisible: false,
      form: {
        id: "",
        inductLevel: "",
        ledNo: "",
        parkingContentFlag: "n",
        contentCaption: "",
        parkingId: "",
        ledcardId: "",
        pushFlag: "n",
        neimaPrefix: "",
        attr1: "",
        remark: "",
      },
      formLabelWidth: "106px",
      parks: [],
      rules: {
        attr1: [
          {
            pattern: /^1[3-9]\d{9}$|^0\d{2,3}-?\d{7,8}$/,
            message: "请输入正确的联系电话格式",
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    Page,
    Refresh
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
    permiss() {},
  },
  mounted() {
    this.search.pageNumber = 1;
    this.tableList(1);
  },
  methods: {
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;

      this.tableList(this.search.pageNumber);
    },
    tableList(curPage) {
      this.tableLoading = true;
      this.$get(queryLedInduct(), {
        limit: this.search.pageSize,
        page: curPage,
        inductLevel: this.search.inductLevel,
        ledcardId: this.search.ledcardId,
        ledcardStatus: this.search.ledcardStatus,
      })
        .then((res) => {
          this.tableListData = res?.data?.rows ?? [];
          var pageObj = {
            curIndex: res.data.offset,
            rowsCount: res.data.total,
          };
          this.pageObj = { ...pageObj };
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    addOrEdit(row) {
      this.form = {
        id: "",
        inductLevel: "",
        ledNo: "",
        parkingContentFlag: "n",
        contentCaption: "",
        parkingId: "",
        ledcardId: "",
        pushFlag: "n",
        neimaPrefix: "",
        attr1: "",
        remark: "",
      };
      if (row) {
        this.$postRequest(queryLedInductOne(), { id: row.id }).then((res) => {
          this.form = res?.data ?? {};
        });
      }
      this.dialogFormVisible = true;
      this.getAllParkingLot();
    },
    del(row) {
      const { id } = row;
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除？",
        {
          btn: ["确定", "取消"],
          shade: true,
        },
        function() {
          _this.$layer.close(index);
          _this.$deleteRequest(updateLedInduct() + "/" + id).then((data) => {
            _this.$message({
              type: data?.status === 200 ? "success" : "error",
              message:
                data?.status === 200 ? "删除成功" : data?.message ?? "删除失败",
            });
            _this.tableList(_this.curIndex);
          });
        }
      );
    },
    searchList() {
      this.search.pageNumber = 1;
      this.tableList(1);
    },
    addOrEditTrue() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false;
        }
        if (this.form.id) {
          this.$putRequest(`${updateLedInduct()}/${this.form.id}`, {
            ...this.form,
          }).then((res) => {
            this.$message({
              type: res?.status === 200 ? "success" : "error",
              message:
                res?.status === 200 ? "修改成功" : res?.message ?? "修改失败",
            });
            if (res.status === 200) {
              this.dialogFormVisible = false;
              this.tableList(this.curIndex);
            }
          });
          return;
        }
        this.$postRequest(updateLedInduct(), this.form).then((res) => {
          this.$message({
            type: res?.status === 200 ? "success" : "error",
            message:
              res?.status === 200 ? "新增成功" : res?.message ?? "新增失败",
          });
          if (res.status === 200) {
            this.dialogFormVisible = false;
            this.search.pageNumber = 1;
            this.tableList(1);
          }
        });
      });
    },
    viewSendLog(row) {
      if (!row || !row.ledcardId) {
        this.$message({
          type: "warning",
          message: "未找到控制卡ID，无法查看下发记录",
        });
        return;
      }
      this.$router.push({
        path: "/main/equipment/guidance-display-screen/log",
        query: {
          ledInductId: row.id,
        },
      });
    },
    getAllParkingLot() {
      this.$get(fetchParkigList()).then((data) => {
        this.parks = data?.data ?? [];
      });
    },
    publish(row) {
      const { id } = row;
      this.$prompt("请输入发布内容", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          this.$get(
            `${publishContent()}?ledInductInfoId=${id}&content=${value}`
          ).then((data) => {
            this.$message({
              type: data?.status === 200 ? "success" : "error",
              message:
                data?.status === 200
                  ? "发布成功!"
                  : data?.message ?? "发布失败!",
            });
          });
          // this.$message({
          //   type: 'success',
          //   message: '内容是: ' + value
          // });
        })
        .catch((error) => {
          console.log("error=>", error);
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
  },
};
</script>
<style>
.guidance-display-screen .el-select {
  display: inline-block;
  vertical-align: middle;
}
</style>
